export const secondInMs = 1000;
export const minuteInMs = 60 * secondInMs;
export const hourInMs = 60 * minuteInMs;
